var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
function _typeof(o) {
  "@babel/helpers - typeof";
  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o2) {
    return typeof o2;
  } : function(o2) {
    return o2 && "function" == typeof Symbol && o2.constructor === Symbol && o2 !== Symbol.prototype ? "symbol" : typeof o2;
  }, _typeof(o);
}
__name(_typeof, "_typeof");
var _excluded = ["className", "children", "isAnchor", "icon", "iconPosition", "linkType", "href", "external", "width", "multiline", "type", "size", "ariaLabel", "title", "disabled", "shape", "onClick", "to", "tabIndex"];
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function(n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
__name(_extends, "_extends");
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: true, configurable: true, writable: true }) : e[r] = t, e;
}
__name(_defineProperty, "_defineProperty");
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
__name(_toPropertyKey, "_toPropertyKey");
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
__name(_toPrimitive, "_toPrimitive");
function _objectWithoutProperties(e, t) {
  if (null == e) return {};
  var o, r, i = _objectWithoutPropertiesLoose(e, t);
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(e);
    for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
__name(_objectWithoutProperties, "_objectWithoutProperties");
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (e.includes(n)) continue;
    t[n] = r[n];
  }
  return t;
}
__name(_objectWithoutPropertiesLoose, "_objectWithoutPropertiesLoose");
import React from "react";
import classnames from "classnames";
import { Button as AntdButton } from "@riseart/antd-provider";
import { Link } from "../link/Link";
import { raBtnCls, raBtnIconRightAlignCls, raBtnAnchorCls, raBtnCircleCls, raBtnTypeLinkCls, raBtnTypeLinkDefaultCls, raBtnTypeLinkStrongCls, raBtnTypeLinkLightCls, raBtnPrimaryCls, raBtnSecondaryCls, raBtnGhostCls, raBtnSizeSmallCls, raBtnSizeMediumCls, raBtnSizeLargeCls, raBtnSizeXLargeCls, raBtnWidthAutoCls, raBtnWidthContainerCls, raBtnWidthFixedCls, raBtnMultilineCls } from "./Button.less";
var RIGHT_ICON_POSITION = "right";
var LEFT_ICON_POSITION = "left";
var TYPE_CLASSNAMES = {
  primary: raBtnPrimaryCls,
  secondary: raBtnSecondaryCls,
  ghost: raBtnGhostCls,
  link: raBtnTypeLinkCls
};
var SIZE_CLASSNAMES = {
  small: raBtnSizeSmallCls,
  medium: raBtnSizeMediumCls,
  large: raBtnSizeLargeCls,
  xlarge: raBtnSizeXLargeCls
};
var WIDTH_CLASSNAMES = {
  auto: raBtnWidthAutoCls,
  container: raBtnWidthContainerCls,
  fixed: raBtnWidthFixedCls
};
var LINK_TYPE_CLASSNAMES = {
  "default": raBtnTypeLinkDefaultCls,
  strong: raBtnTypeLinkStrongCls,
  light: raBtnTypeLinkLightCls
};
var SHAPE_CLASSNAMES = {
  circle: raBtnCircleCls
};
var Button = /* @__PURE__ */ __name(function Button2(_ref) {
  var className = _ref.className, _ref$children = _ref.children, children = _ref$children === void 0 ? null : _ref$children, _ref$isAnchor = _ref.isAnchor, isAnchor = _ref$isAnchor === void 0 ? false : _ref$isAnchor, _ref$icon = _ref.icon, icon = _ref$icon === void 0 ? null : _ref$icon, _ref$iconPosition = _ref.iconPosition, iconPosition = _ref$iconPosition === void 0 ? LEFT_ICON_POSITION : _ref$iconPosition, _ref$linkType = _ref.linkType, linkType = _ref$linkType === void 0 ? null : _ref$linkType, _ref$href = _ref.href, href = _ref$href === void 0 ? null : _ref$href, _ref$external = _ref.external, external = _ref$external === void 0 ? false : _ref$external, _ref$width = _ref.width, width = _ref$width === void 0 ? "auto" : _ref$width, _ref$multiline = _ref.multiline, multiline = _ref$multiline === void 0 ? false : _ref$multiline, _ref$type = _ref.type, type = _ref$type === void 0 ? "primary" : _ref$type, _ref$size = _ref.size, size = _ref$size === void 0 ? "large" : _ref$size, _ref$ariaLabel = _ref.ariaLabel, ariaLabel = _ref$ariaLabel === void 0 ? null : _ref$ariaLabel, _ref$title = _ref.title, title = _ref$title === void 0 ? null : _ref$title, _ref$disabled = _ref.disabled, disabled = _ref$disabled === void 0 ? false : _ref$disabled, _ref$shape = _ref.shape, shape = _ref$shape === void 0 ? null : _ref$shape, _ref$onClick = _ref.onClick, onClick = _ref$onClick === void 0 ? function() {
  } : _ref$onClick, _ref$to = _ref.to, to = _ref$to === void 0 ? null : _ref$to, _ref$tabIndex = _ref.tabIndex, tabIndex = _ref$tabIndex === void 0 ? null : _ref$tabIndex, restProps = _objectWithoutProperties(_ref, _excluded);
  var commonProps = {
    shape,
    onClick,
    to,
    tabIndex
  };
  var computedClassNames = classnames(type && TYPE_CLASSNAMES[type], size && SIZE_CLASSNAMES[size], shape && SHAPE_CLASSNAMES[shape], width && WIDTH_CLASSNAMES[width], _defineProperty({}, raBtnIconRightAlignCls, iconPosition === RIGHT_ICON_POSITION), className);
  var generatedAriaLabel = ariaLabel || typeof title === "string" && title || typeof children === "string" && children || null;
  var ariaProps = generatedAriaLabel ? {
    "aria-label": generatedAriaLabel
  } : null;
  return isAnchor ? /* @__PURE__ */ React.createElement(Link, _extends({}, restProps, commonProps, ariaProps, {
    title,
    href,
    external,
    className: classnames(raBtnCls, raBtnAnchorCls, computedClassNames),
    disabled,
    icon
  }), children, iconPosition === RIGHT_ICON_POSITION && icon) : /* @__PURE__ */ React.createElement(AntdButton, _extends({}, restProps, commonProps, ariaProps, {
    title,
    className: classnames(raBtnCls, computedClassNames, multiline === true ? raBtnMultilineCls : null, type === "link" && LINK_TYPE_CLASSNAMES[linkType || "default"]),
    icon: iconPosition === LEFT_ICON_POSITION && icon ? icon : null,
    disabled
  }), children, iconPosition === RIGHT_ICON_POSITION && icon || null);
}, "Button");
export {
  Button
};
